// Controlled toggle switch used across gestion instead of native checkboxes
// for independent boolean settings.

type ToggleProps = {
  checked: boolean
  onChange: (v: boolean) => void
  label: string
  /** Accessible name for the checkbox when `label` is left empty for visual reasons (e.g. the name is already shown by a sibling element). */
  ariaLabel?: string
  description?: string
  disabled?: boolean
}

export function Toggle({ checked, onChange, label, ariaLabel, description, disabled }: ToggleProps) {
  return (
    <label className={`flex cursor-pointer items-start gap-3 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <div className="relative mt-0.5 shrink-0">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          aria-label={!label ? ariaLabel : undefined}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
        />
        <div
          className={`h-6 w-11 rounded-full transition-colors duration-200 ${
            checked ? 'bg-brand-500' : 'bg-gray-300 dark:bg-gray-600'
          }`}
        />
        <div
          className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-200 ${
            checked ? 'translate-x-[22px]' : 'translate-x-0.5'
          }`}
        />
      </div>
      <div className="min-w-0">
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{label}</span>
        {description && (
          <p className="text-xs text-gray-500 dark:text-gray-500 mt-0.5">{description}</p>
        )}
      </div>
    </label>
  )
}
